"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditDomain = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../../../common/utils");
const VerticalStack_1 = __importDefault(require("@mdigital/components/dist/components/VerticalStack"));
const alchemy_ui_1 = require("@m/alchemy-ui");
const react_final_form_1 = require("react-final-form");
const helpers_1 = require("../helpers");
const TextPathPrefix = 'app.pages.administration.domainsList';
const Update = `${TextPathPrefix}.update`;
const Cancel = `${TextPathPrefix}.cancel`;
const Title = `${TextPathPrefix}.editDomain`;
const Label = `${TextPathPrefix}.domainURL`;
const DomainError = `${TextPathPrefix}.domainError`;
const DomainDuplicationError = `${TextPathPrefix}.domainDuplicationError`;
const Placeholder = `${TextPathPrefix}.placeholder`;
const EditDomain = (props) => {
    const { domainNames } = props;
    const { domainName } = props.data;
    const domainList = domainNames.filter((domain) => domain !== domainName);
    const body = (react_1.default.createElement("div", null,
        react_1.default.createElement(VerticalStack_1.default, { gap: 'small' },
            react_1.default.createElement(react_final_form_1.Field, { name: 'domainName', validate: (value) => (0, helpers_1.validation)(value, domainList, DomainError, DomainDuplicationError), render: ({ input, meta }) => (react_1.default.createElement(alchemy_ui_1.Field, { required: true, isFullWidth: true, label: (0, utils_1.getSingleText)(Label), input: react_1.default.createElement(alchemy_ui_1.Input, Object.assign({ placeholder: (0, utils_1.getSingleText)(Placeholder) }, input)), status: meta.error && meta.touched ? { level: 'error', message: meta.error } : undefined })) }))));
    const onSubmit = (value) => __awaiter(void 0, void 0, void 0, function* () {
        props.onSubmit(props.data, value.domainName.trim());
        return Promise.resolve();
    });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmit, initialValues: { domainName: domainName }, render: ({ handleSubmit }) => props.render({
                size: 'small',
                close: {
                    title: (0, utils_1.getSingleText)(Cancel),
                },
                submit: {
                    callback: (context) => {
                        var _a;
                        (_a = handleSubmit()) === null || _a === void 0 ? void 0 : _a.then(() => context.close());
                    },
                    title: (0, utils_1.getSingleText)(Update),
                    shouldAutoClose: false,
                },
                body: body,
                title: (0, utils_1.getSingleText)(Title),
                description: react_1.default.createElement(react_1.default.Fragment, null),
            }) })));
};
exports.EditDomain = EditDomain;
